import { useState, useEffect, type FC } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { trackEvent, trackEcommerce, trackingConstants, eventNameConstants } from 'dibs-tracking';

import dibsCss from 'dibs-css';
import { type ItemType } from 'dibs-recent-history/exports/types.ts';
import styles from './SearchBarRecentlyViewedItems.module.css';

type Props = {
    recentlyViewedItems: ItemType[];
};
export const SearchBarRecentlyViewedItems: FC<Props> = ({ recentlyViewedItems }) => {
    const [hasFiredImpressions, setHasFiredImpressions] = useState(false);
    const { ECOM_PRODUCT_CLICK, ECOM_PRODUCT_IMPRESSION } = trackingConstants;
    const { EVENT_SELECT_ITEM, EVENT_VIEW_ITEM_LIST } = eventNameConstants;

    const trackClick = (item: ItemType, index: number): void => {
        trackEvent({
            category: 'promo interaction',
            action: 'recently viewed - global search items clicked',
            label: 'none',
            value: 0,
        });
        trackEcommerce({
            type: ECOM_PRODUCT_CLICK,
            eventName: EVENT_SELECT_ITEM,
            actionField: { list: 'recently viewed - global search', itemId: item.itemId },
            products: [
                {
                    id: item.itemId,
                    dimension83: item.contemporaryTrackingString,
                    position: index + 1,
                    brand: item.dealerPk ?? '',
                    list: 'recently viewed - global search',
                },
            ],
        });
    };

    useEffect(() => {
        if (!hasFiredImpressions) {
            trackEcommerce({
                type: ECOM_PRODUCT_IMPRESSION,
                eventName: EVENT_VIEW_ITEM_LIST,
                actionField: { list: 'recently viewed - global search' },
                products: recentlyViewedItems.map((item, index) => ({
                    id: item.itemId,
                    dimension83: item.contemporaryTrackingString,
                    position: index + 1,
                    brand: item.dealerPk ?? '',
                    list: 'recently viewed - global search',
                })),
            });
            setHasFiredImpressions(true);
        }
    }, [
        recentlyViewedItems,
        hasFiredImpressions,
        setHasFiredImpressions,
        ECOM_PRODUCT_IMPRESSION,
        ECOM_PRODUCT_CLICK,
        EVENT_VIEW_ITEM_LIST,
        EVENT_SELECT_ITEM,
    ]);

    return (
        <div className={dibsCss.mxSmall}>
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.flexNowrap,
                    dibsCss.gapXsmall,
                    dibsCss.wFull,
                    dibsCss.overflowHidden
                )}
            >
                {recentlyViewedItems.map((item, index) => (
                    <Link
                        key={item.itemPdpUrl}
                        className={classnames(styles.linkImage, dibsCss.block)}
                        href={item.itemPdpUrl}
                        onClick={() => trackClick(item, index)}
                    >
                        <img
                            className={classnames(
                                dibsCss.hXlarge,
                                dibsCss.wXlarge,
                                dibsCss.objectContain
                            )}
                            src={item.itemImageUrl}
                            alt={item.itemTitle}
                        />
                    </Link>
                ))}
            </div>
        </div>
    );
};
